import React, { Component } from 'react';
import './AdBlock.css';

class AdBlock extends Component {

    render () {
        let locale = this.props.locale;

        switch (locale) {
            case 'it':
                return (
                    <div className="ad-block" >

                        <script type="text/javascript" id="gbconfigscript" src="//gbucket.ch/CH/ch_config_mobile.js"></script>
                        <script type="text/javascript" id="gbadtag" src="//gbucket.ch/CH/AhrinaGmbH/IT_Hockeyinfo_APP_RoS.js"></script>
                        <div id="div-ad-gds-892-1">
                            <script type="text/javascript">gbcallslot892("div-ad-gds-892-1","CLICK_URL_UNESC")</script>
                        </div>

                    </div>

                );
            case 'fr':
                return (
                    <div className="ad-block" >

                        <script type="text/javascript" id="gbconfigscript" src="//gbucket.ch/CH/ch_config_mobile.js"></script>
                        <script type="text/javascript" id="gbadtag" src="//gbucket.ch/CH/AhrinaGmbH/FR_Hockeyinfo_APP_RoS.js"></script>
                        <div id="div-ad-gds-891-1">
                            <script type="text/javascript">gbcallslot891("div-ad-gds-891-1","CLICK_URL_UNESC")</script>
                        </div>

                    </div>

                );
            default:
                return (
                    <div className="ad-block" >

                        <script type="text/javascript" id="gbconfigscript" src="//gbucket.ch/CH/ch_config_mobile.js"></script>
                        <script type="text/javascript" id="gbadtag" src="//gbucket.ch/CH/AhrinaGmbH/DE_Hockeyinfo_APP_RoS.js"></script>
                        <div id="div-ad-gds-890-1">
                            <script type="text/javascript">gbcallslot890("div-ad-gds-890-1","CLICK_URL_UNESC")</script>
                        </div>

                    </div>

                );
        }
    }
}

export default AdBlock;


// WEBPACK FOOTER //
// ./src/External/AdBlock.js